module.exports = __webpack_public_path__ + "img/lg_ring_r_c_0_1@3x.047cfd80.png";